var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"margin-bottom":"0"}},[_c('span',{staticClass:"status-style",style:(_vm.statusColors[_vm.status])},[_vm._v("\n    "+_vm._s(_vm.formatStatus)+"\n  ")]),_vm._v(" "),_vm._t("pendingReason")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }